<button
  mat-button
  [attr.aria-label]="ariaLabel"
  [type]="type"
  [tabIndex]="tabIndex"
  [disabled]="isDisabledState"
  [color]="color"
>
  <ng-content></ng-content>
  <div class="button-content">
    <span class="button-label" *ngIf="labelPosition === 'left'">{{ label }}</span>
    <sn-icon *ngIf="icon">{{ icon }}</sn-icon>
    <span class="button-label" *ngIf="labelPosition === 'right'">{{ label }}</span>
  </div>

  <ng-template [ngIf]="isLoadingState">
    <mat-spinner diameter="24"></mat-spinner>
  </ng-template>
</button>
